import { formatMoney } from '../lib/money';

const TILES = [
  { key: 'due_now',        label: 'Due Now' },
  { key: 'due_this_week',  label: 'Due This Week' },
  { key: 'overdue',        label: 'Overdue' },
  { key: 'disputed',       label: 'Disputed' },
  { key: 'drafts',         label: 'Drafts' }
];

export default function KpiStrip({ kpis, activeKey, onSelect }) {
  return (
    <div className="kpi-strip">
      {TILES.map(t => {
        const row = kpis[t.key] || { amount: 0, count: 0 };
        const active = activeKey === t.key;
        return (
          <button
            key={t.key}
            type="button"
            className={`kpi-tile ${active ? 'active' : ''}`}
            onClick={() => onSelect(active ? null : t.key)}
            aria-pressed={active}
          >
            <div className="kpi-head">
              <span className="kpi-label">{t.label}</span>
              <span className="kpi-count">{row.count}</span>
            </div>
            <div className="kpi-amount">{formatMoney(row.amount)}</div>
          </button>
        );
      })}
    </div>
  );
}
